import { render, staticRenderFns } from "./ListCollecting.vue?vue&type=template&id=03183950&scoped=true"
import script from "./ListCollecting.vue?vue&type=script&lang=js"
export * from "./ListCollecting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03183950",
  null
  
)

export default component.exports